import React, { useEffect, useState } from "react";
import { Container, Grid, Card, CardContent, Typography, Box } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import Header from "../Header/Header";

const API_URL = process.env.REACT_APP_API_URL;

const DataAnalytics = ({ userId, loggedIn, onLogout }) => {
  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
}, []);

  const [analyticsData, setAnalyticsData] = useState({
    total_users: 0,
    total_verified_users: 0,
    total_hosted_sessions: 0,
    total_booked_sessions: 0,
    total_request_sessions: 0,
    total_accepted_sessions: 0,
    total_request_user_sessions: 0,
    total_organizations: 0,
    total_transactions: 0,
    total_queries: 0,
    total_contact_us: 0,
    total_asked_questions: 0,
  });

  const navigate = useNavigate();

  // Map each metric to a specific route
  const analyticsRoutes = {
    total_unverified_users: "/admin-view-all-users",
    total_verified_users: "/admin-view-verified-users",
    total_hosted_sessions: "/hosted-sessions",
    total_booked_sessions: "/bookings",
    total_request_sessions: "/requests",
    total_accepted_sessions: "/accepted-requests",
    total_request_user_sessions: "/user-requests",
    total_organizations: "/organizations",
    total_transactions: "/transactions",
    total_queries: "/support-queries",
    total_contact_us: "/contact-submissions",
    total_asked_questions: "/questions",
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/get_data_analytics/`)
      .then((response) => {
        setAnalyticsData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#000000" }}>
      {loggedIn ? (
        <Header1
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            backgroundColor: "#000000",
            padding: "1rem",
            color: "white",
          }}
          userId={userId}
          onLogout={onLogout}
        />
      ) : (
        <Header
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            backgroundColor: "#000000",
            padding: "1rem",
            color: "white",
          }}
        />
      )}

      <Container
        maxWidth="lg"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem 1rem",
          backgroundColor: "#000000",
        }}
      >
        <Box
          my={4}
          mt={10}
          style={{
            width: "100%",
            textAlign: "center",
            padding: "1rem",
            backgroundColor: "#1111",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom style={{ fontWeight: 600, color: "white" }}>
            Data Analytics Dashboard
          </Typography>

          <Grid container spacing={4}>
            {Object.entries(analyticsData).map(([key, value]) => (
              <Grid item xs={12} sm={6} md={4} key={key}>
                <Card
                  onClick={() => {
                    const route = analyticsRoutes[key];
                    if (route) navigate(route);
                  }}
                  style={{
                    cursor: analyticsRoutes[key] ? "pointer" : "default",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                    padding: "2rem",
                    backgroundColor: "#1111",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      component="div"
                      style={{
                        fontWeight: 600,
                        color: "#ffffff",
                        textTransform: "capitalize",
                      }}
                    >
                      {key.replace(/_/g, " ")}
                    </Typography>
                    <Typography variant="h5" style={{ marginTop: "10px", fontWeight: 500, color: "white" }}>
                      {value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      <Footer2
        style={{
          backgroundColor: "#000000",
          color: "white",
          padding: "1rem",
          textAlign: "center",
          marginTop: "auto",
        }}
      />
    </div>
  );
};

export default DataAnalytics;
